// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1jtDW","content":"RecentSearches_content__16dCO"};